import { FC } from 'react'

import { useAcknowledgementReceivers } from './api/useAcknowledgementReceivers'
import { AcknowledgementReceiversCard } from './components/AcknowledgementReceiversCard'

export type AcknowledgementReceiversProps = {
  // Shipment code (subscriptions reference id); omitted on the pre-shipment booking view.
  referenceId?: string
  bookingRecipients?: string[]
}

export const AcknowledgementReceivers: FC<AcknowledgementReceiversProps> = ({ referenceId, bookingRecipients }) => {
  const { receivers } = useAcknowledgementReceivers({ referenceId, bookingRecipients })

  if (receivers.length === 0) {
    return null
  }

  return <AcknowledgementReceiversCard receivers={receivers} />
}
